import * as types from './constants'

export const setIsMobile = isMobile => dispatch => (dispatch({
	type: types.SET_IS_MOBILE,
	isMobile,
}))

